'use strict';
const State = require('process/domain/entity/action/state');
const StateType = require('process/domain/entity/state-type');

class Factory {
    constructor(project) {
        this._project = project;
    }

    build(json) {
        return new Promise((resolve, reject) => {
            let p = new State(json);
            p.set({type: StateType.get(json.type)});
            p.set({_project: this._project});
            resolve(p);
        });
    }
}

module.exports = Factory;



// WEBPACK FOOTER //
// ./process/domain/factory/action/state.js